// extracted by mini-css-extract-plugin
module.exports = {"items":"DashCard_items__vv322","paper":"DashCard_paper__1P0c6"};